import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { HotelBed } from '@withjoy/joykit/icons';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { MapPinWithLabel } from '@shared/components/JoyInteractableMap/MapPin';
import { useMapTelemetry } from './Map.telemetry';
import { AccommodationListingDTO } from '@apps/accommodations/AccommodationsConsole.types';

interface MapMarkerProps {
  hotel: AccommodationListingDTO;
  isHighlighted: boolean;
  activeMarker?: string;
  onClickMarker: (hotel: AccommodationListingDTO) => void;
  isHoveringAddedHotel?: boolean;
}

export const MapMarker: React.FC<MapMarkerProps> = props => {
  const { hotel, isHighlighted, activeMarker, onClickMarker, isHoveringAddedHotel } = props;
  const telemetry = useMapTelemetry();

  const isCardVisible = activeMarker === hotel.joyPlaceId;
  const price = hotel.pricingInfo.values?.nightlyBaseRateString;

  const handleMapPin = useEventCallback(e => {
    e.stopPropagation();
    telemetry.mapMarkerClicked({ listingType: hotel.type, placeId: hotel.joyPlaceId, hotelName: hotel.name, from: 'fullMap' });
    onClickMarker(hotel);
  });

  return (
    <MapPinWithLabel
      key={hotel.joyPlaceId}
      position={hotel.location}
      isActive={isHighlighted}
      showOnTop={isHighlighted}
      {...(isHoveringAddedHotel && { transform: 'scale(1.2)' })}
      showImageOnHover={!hotel.isPickedByCouple}
      isCardVisible={isCardVisible}
      onClick={handleMapPin}
      {...(hotel.isPickedByCouple && {
        mapPinColor: 'newUIBrandPrimary',
        mapPinHighlightColor: 'newUIBrandPrimary',
        hoverColor: 'newUIBrandPrimary'
      })}
      onDoubleClick={e => {
        e.stopPropagation();
      }}
      image={hotel.mediaAssets?.photos?.[0]?.url ? `url(${hotel.mediaAssets?.photos?.[0]?.url})` : ''}
      label={
        <Flex justifyContent="center" alignItems="center" columnGap={2} {...(hotel.isPickedByCouple && { color: 'white' })}>
          <HotelBed size="sm" />
          {price && <TextV2 typographyVariant="label3">{price}</TextV2>}
        </Flex>
      }
    />
  );
};
